export { default } from './BadgeLocation';
